module.exports = __webpack_public_path__ + "static/img/recovery.bce69597.png";